import React from 'react';
import { AlertCircle, CheckCircle, AlertTriangle, Info } from 'lucide-react';

const variantStyles = {
  error: {
    container: 'bg-red-50 border-red-200 text-red-800',
    icon: AlertCircle,
    iconClass: 'text-red-500'
  },
  warning: {
    container: 'bg-yellow-50 border-yellow-200 text-yellow-800',
    icon: AlertTriangle,
    iconClass: 'text-yellow-500'
  },
  info: {
    container: 'bg-blue-50 border-blue-200 text-blue-800',
    icon: Info,
    iconClass: 'text-blue-500'
  },
  success: {
    container: 'bg-green-50 border-green-200 text-green-800',
    icon: CheckCircle,
    iconClass: 'text-green-500'
  }
};

export const Alert = ({ children, variant = 'error', icon = true }) => {
  const styles = variantStyles[variant] || variantStyles.error;
  const IconComponent = styles.icon;

  return (
    <div className={`border rounded-lg p-4 flex items-start ${styles.container}`}>
      {icon && (
        <IconComponent className={`mt-0.5 mr-3 flex-shrink-0 ${styles.iconClass}`} size={16} />
      )}
      <div className="text-sm">{children}</div>
    </div>
  );
};
